/*------------------------------------*\
    know your suit
\*------------------------------------*/

module.exports = function(){

    var $video = $('.js-know-your-suit-video'),
        $videoParent = $('.js-get-educated-tab[data-tab="know-your-suit"]'),
        $heading = $('.js-know-your-suit-heading'),
        $images = $('.js-know-your-suit-images'),
        $image = $('.js-know-your-suit-image'),
        $details = $('.js-know-your-suit-details'),
        $progress = $('.js-know-your-suit-progress'),
        $progressPoint = $('.js-know-your-suit-progress-point'),
        $windowWidth = $(window).width();

    if($windowWidth >= 900) {

        // Play when the parent tab is active

        $videoParent.on('tabopen', function() {

            if($videoParent.hasClass('is-current')) {
                $video.get(0).play();
            }

        });

        // Add interface

        $video.on('timeupdate', function() {

            if(this.currentTime > this.duration-8) {
                $heading.addClass('is-active');
            }

            if(this.currentTime > this.duration-5) {
                $details.first().addClass('is-active');
                $progress.addClass('is-active');
            }

        });

        // Fade out video

        $video.on('ended', function() {
            $video.addClass('is-ended');
            $images.addClass('is-active');
            $image.first().addClass('is-active');
        });

    } else {

        // Don't show the video on mobile

        $video.addClass('is-inactive');
        $heading.addClass('is-active');
        $details.first().addClass('is-active');
        $images.addClass('is-active');
        $image.first().addClass('is-active');
        $progress.addClass('is-active');

    }

    // Clickable points

    $progressPoint.on('click', function(){
        var $pointIndex = $(this).data('point'),
            $pointImage = $('.js-know-your-suit-image[data-point="' + $pointIndex + '"]'),
            $pointDetails = $('.js-know-your-suit-details[data-point="' + $pointIndex + '"]');

        $image.removeClass('is-active');
        $details.removeClass('is-active');
        $progressPoint.removeClass('is-active');

        $pointImage.addClass('is-active');
        $pointDetails.addClass('is-active');
        $(this).addClass('is-active');
    });

}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/blocks/know-your-suit.js